import { ICategory } from '../interfaces/i-category';

export const CATEGORIES: ICategory[] = [
  {
    CategoriesIds:
      '1340538d-285a-4e27-9384-840a3ce390ee,cdc97628-fc1e-441d-85fc-28fadb465cd0,df7fc366-b144-4bae-b85f-14bd4dbe4207,8f96ab2a-ad48-4aa7-8990-2281fadf6760,835396cd-1b0d-4e8f-a541-ad225a17947a,21352edf-877f-47a7-aaac-9615341f6dfb,fbb1cae1-4c5e-487b-9734-6bddc7265b2b,cddf33e3-75a5-4f45-bc2e-a08d39b61ded,4eeeb173-bf76-4add-a14f-5ad538a9e10a,34736126-4d1b-4abe-8fca-2901a8269611,f4e676ae-0446-4db7-a383-7814f1fbc10e,08bad554-4ea6-4988-8b6b-03392d02a4e7,fcb5ee01-e42c-46e6-bc52-f11f3c2ed875,33092717-b468-46a6-975c-784d7c707fa1,71792136-2b62-4dfa-917e-d2fdf4c275ed,72c224ba-7512-41c9-a2bd-bd19a4a7e923,02f80e1e-4d57-4ada-bf8f-6d240da74711,17af4623-2e1f-4a42-a554-84953efd9cb7,870b11bb-b54c-4e68-b766-b3eb864f0119,c259f8de-6dcd-47ab-8712-451ba7e30cea,fffd8303-e3cb-43b2-a551-07d486636cf7,24574b33-6213-4ca7-81c0-646b1088701b,76647e6a-e7dc-4dd0-9526-75e530f13099,bad08e07-28f9-4e3c-afc5-c0e24a4ba8a1,c03226fa-0a92-4b03-9221-6d7ba9e0524a,fef6af23-88fc-4732-9d09-9a3b5a4492f3',
    Name: 'Outros',
    IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
    SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
    CreationDate: '2020-01-01T08:00:00',
    Categories: [
      {
        Name: 'Brasileira',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '1340538d-285a-4e27-9384-840a3ce390ee',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Happy Hour',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: 'cdc97628-fc1e-441d-85fc-28fadb465cd0',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Bebidas',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: 'df7fc366-b144-4bae-b85f-14bd4dbe4207',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Alemã',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '8f96ab2a-ad48-4aa7-8990-2281fadf6760',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Comida caseira',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '835396cd-1b0d-4e8f-a541-ad225a17947a',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Marmita',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '21352edf-877f-47a7-aaac-9615341f6dfb',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Cozinha rápida',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: 'fbb1cae1-4c5e-487b-9734-6bddc7265b2b',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Argentina',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: 'cddf33e3-75a5-4f45-bc2e-a08d39b61ded',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Contemporânea',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '4eeeb173-bf76-4add-a14f-5ad538a9e10a',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Peixes',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '34736126-4d1b-4abe-8fca-2901a8269611',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Variada',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: 'f4e676ae-0446-4db7-a383-7814f1fbc10e',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Vegetariana',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '08bad554-4ea6-4988-8b6b-03392d02a4e7',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Sorvetes',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: 'fcb5ee01-e42c-46e6-bc52-f11f3c2ed875',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Lanches',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '33092717-b468-46a6-975c-784d7c707fa1',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Xis',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '71792136-2b62-4dfa-917e-d2fdf4c275ed',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Árabe',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '72c224ba-7512-41c9-a2bd-bd19a4a7e923',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Saudável',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '02f80e1e-4d57-4ada-bf8f-6d240da74711',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Salgados',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '17af4623-2e1f-4a42-a554-84953efd9cb7',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Gaúcha',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '870b11bb-b54c-4e68-b766-b3eb864f0119',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Mediterrânea',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: 'c259f8de-6dcd-47ab-8712-451ba7e30cea',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Portuguesa',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: 'fffd8303-e3cb-43b2-a551-07d486636cf7',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Baiana',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '24574b33-6213-4ca7-81c0-646b1088701b',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Sopas e Caldos',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '76647e6a-e7dc-4dd0-9526-75e530f13099',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Nordestina',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: 'bad08e07-28f9-4e3c-afc5-c0e24a4ba8a1',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Típica do Norte',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: 'c03226fa-0a92-4b03-9221-6d7ba9e0524a',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Yakisoba',
        IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/outros.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: 'fef6af23-88fc-4732-9d09-9a3b5a4492f3',
        CreationDate: '2020-01-01T08:00:00',
      },
    ],
    Slug: 'outros',
  },
  {
    Name: 'Italiana',
    IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/italiana.png',
    SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
    Id: '6a30df8b-dfb8-415b-ad3a-41060e1fd633',
    CreationDate: '2020-01-01T08:00:00',
    Slug: 'italiana',
  },
  {
    Name: 'Pizza',
    IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/pizza.png',
    SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
    Id: 'a6f42a0c-cd09-4c39-b987-ca60ff33ad3d',
    CreationDate: '2020-01-01T08:00:00',
    Slug: 'pizza',
  },
  {
    Name: 'Doces e Bolos',
    IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/doces.png',
    SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
    Id: '6ee48a61-6954-4771-aea7-efdfb807cd0a',
    CreationDate: '2020-01-01T08:00:00',
    Slug: 'doces-e-bolos',
  },
  {
    Name: 'Frutos do Mar',
    IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/frutos.png',
    SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
    Id: '897a941c-cc22-4ca5-b4dc-fe17d8aca0ca',
    CreationDate: '2020-01-01T08:00:00',
    Slug: 'frutos-do-mar',
  },
  {
    Name: 'Carnes',
    IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/carnes.png',
    SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
    Id: '0054363f-226e-4241-a645-c0b6de25e132',
    CreationDate: '2020-01-01T08:00:00',
    Slug: 'carnes',
  },
  {
    CategoriesIds:
      '52014862-421e-4176-af56-1ef9c2b65371,83261c8c-730e-4fbf-8dd6-b573de5ef5c5,0132e5db-1019-49b8-9236-e1375433a00b,4e8c2e53-f220-44b8-bda4-6169551c667a',
    Name: 'Oriental',
    IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/oriental.png',
    SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
    CreationDate: '2020-01-01T08:00:00',
    Categories: [
      {
        Name: 'Japonesa',
        IconPath:
          'https://dev-mobo-images.s3.amazonaws.com/static/oriental.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '52014862-421e-4176-af56-1ef9c2b65371',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Asiática',
        IconPath:
          'https://dev-mobo-images.s3.amazonaws.com/static/oriental.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '83261c8c-730e-4fbf-8dd6-b573de5ef5c5',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Chinesa',
        IconPath:
          'https://dev-mobo-images.s3.amazonaws.com/static/oriental.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '0132e5db-1019-49b8-9236-e1375433a00b',
        CreationDate: '2020-01-01T08:00:00',
      },
      {
        Name: 'Tailandesa',
        IconPath:
          'https://dev-mobo-images.s3.amazonaws.com/static/oriental.png',
        SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
        Id: '4e8c2e53-f220-44b8-bda4-6169551c667a',
        CreationDate: '2020-01-01T08:00:00',
      },
    ],
    Slug: 'oriental',
  },
  {
    Name: 'Hambúrguer',
    IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/burger.png',
    SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
    Id: '8d2e334d-687c-4b90-9337-c03c4da75747',
    CreationDate: '2020-01-01T08:00:00',
    Slug: 'hamburguer',
  },
  {
    Name: 'Frangos',
    IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/frangos.png',
    SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
    Id: 'acd34c7a-ce7e-46d9-a8bc-50ba45756953',
    CreationDate: '2020-01-01T08:00:00',
    Slug: 'frangos',
  },
  {
    Name: 'Fondue',
    IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/fondue.png',
    SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
    Id: '95cd5cbf-2a25-4aaf-a170-c6ead73e977b',
    CreationDate: '2020-01-01T08:00:00',
    Slug: 'fondue',
  },
  {
    Name: 'Padaria',
    IconPath: 'https://dev-mobo-images.s3.amazonaws.com/static/padaria.png',
    SegmentId: 'd296bd9a-1137-45e8-a7f5-1fcfc4107273',
    Id: '2c3a4fb5-c0e9-4534-afde-e742b12c5715',
    CreationDate: '2020-01-01T08:00:00',
    Slug: 'padaria',
  },
];
